module.exports = __webpack_public_path__ + "static/media/Graduate.830c050f.jpg";